import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useOopMaximumScheduleStep from "./hooks/useOutOfPocketMaxScheduleStepsDetailExt";

const OutOfPocketMaxScheduleStepsDetailExt = () => {
  const oopMaximumScheduleStepData = useOopMaximumScheduleStep();

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={oopMaximumScheduleStepData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {oopMaximumScheduleStepData.screen_title} -{" "}
          <span className="heading-cod">
            {oopMaximumScheduleStepData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={oopMaximumScheduleStepData.formFields}
        dropdownValues={oopMaximumScheduleStepData.dropdownValues}
        paramsData={oopMaximumScheduleStepData.paramsData}
        updataParamData={oopMaximumScheduleStepData.updateParamData}
      />
      <ButtonsSection ctaButtons={oopMaximumScheduleStepData.ctaButtons} />
      <DisplayTable
        data={oopMaximumScheduleStepData.data}
        parmKey={oopMaximumScheduleStepData.parmKey}
        menuOptions={oopMaximumScheduleStepData.menuOptions}
        tableHeaders={oopMaximumScheduleStepData.columnDef}
        setRowData={oopMaximumScheduleStepData.setRowData}
        selectedPriceSchedules={oopMaximumScheduleStepData.selectedRows}
        setSelectedPriceSchedules={oopMaximumScheduleStepData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={oopMaximumScheduleStepData.first}
          rows={oopMaximumScheduleStepData.rows}
          totalRecords={oopMaximumScheduleStepData.totalRecords}
          currentPage={oopMaximumScheduleStepData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={oopMaximumScheduleStepData.onPageChange}
        />
      </div>
      {oopMaximumScheduleStepData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={oopMaximumScheduleStepData.isConfirmationModalOpen}
          onRequestClose={oopMaximumScheduleStepData.closeConfirmationModal}
          onBack={oopMaximumScheduleStepData.closeConfirmationModal}
          onSave={oopMaximumScheduleStepData.deleteOopMaximumScheduleStep}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={oopMaximumScheduleStepData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default OutOfPocketMaxScheduleStepsDetailExt;
